import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Yearlevel_map.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IYearlevel_map } from "./IYearlevel_map";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import Yearlevel_mapForm from "./Yearlevel_mapForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";
import { clearAddYearlevel_mapResponse } from "../../Redux/Slices/Yearlevel_map/AddYearlevel_mapSlice";
import {
  clearDeleteYearlevel_mapResponse,
  deleteYearlevel_map,
} from "../../Redux/Slices/Yearlevel_map/DeleteYearlevel_mapSlice";
import { clearEditYearlevel_mapResponse } from "../../Redux/Slices/Yearlevel_map/EditYearlevel_mapSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listyearGroup } from "../../Redux/Slices/yearGroup/ListyearGroupSlice";
import { listPackageDomain } from "../../Redux/Slices/Package/ListPackageDomainSlice";
import { listCountry } from "../../Redux/Slices/Country/ListCountrySlice";


interface Yearlevel_mapProps { }

const Yearlevel_map: FunctionComponent<Yearlevel_mapProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IYearlevel_map | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listYearlevel_maps } = useAppSelector(
    (state) => state.ListYearlevel_mapSlice
  );
  const { data: addYearlevel_map } = useAppSelector(
    (state) => state.AddYearlevel_mapSlice
  );
  const { data: EditYearlevel_map } = useAppSelector(
    (state) => state.EditYearlevel_mapSlice
  );
  const { data: deleteYearlevel_maps } = useAppSelector(
    (state) => state.DeleteYearlevel_map
  );

  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
     {
      field: "domain",
      headerName: "Domain",
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params) => <span>{params.row?.domain || "-"}</span>,
    },
    {
      field: "yeargroup",
      headerName: "Year group",
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params) => <span>{params.row.yeargroup?.name || "-"}</span>,
    },
    {
      field: "region",
      headerName: "Region",
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params) => {
        const name = params.row.region?.name;
        const state = params.row.region?.state;
        return `${name || "-"}, ${state || "-"}`;
      },
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IYearlevel_map>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Yearlevel_map = Array.isArray(listYearlevel_maps?.data)
    ? listYearlevel_maps?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(listYearlevel_map());
    dispatch(listyearGroup());
    dispatch(listCountry());
    dispatch(listPackageDomain());
    // dispatch(listSideMenuPermission());
  }, [addYearlevel_map, EditYearlevel_map, deleteYearlevel_maps, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearAddYearlevel_mapResponse());
      dispatch(clearEditYearlevel_mapResponse());
      dispatch(clearDeleteYearlevel_mapResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={Yearlevel_map ?? []} columns={columns} exportFileName="Year_Level_Mapping">
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({ status: true });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listYearlevel_map())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Year Level Mapping`}
        dialogContentClassName="dialog_content"
        Dialog_Content={
          <Yearlevel_mapForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={addYearlevel_map}
        parentDialog={setDialogOpen}
      />
      <ResponseDialog
        response={EditYearlevel_map}
        parentDialog={setDialogOpen}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteYearlevel_map(deleteDialogData.id));
        }}
        response={deleteYearlevel_maps}
      />
    </>
  );
};

export default Yearlevel_map;
